export const zIndex = {
  zIndex1: 1,
  zIndex2: 2,
  zIndex3: 3,
  zIndex4: 4,
  zIndex5: 5,
  zIndex6: 6,
};
